module.exports = __webpack_public_path__ + "img/1510052342.9acacb8a.jpg";